<!-- <deloitteai-page
  [logoUrl]="logoUrl"
  [desktopHamburgerLogoUrl]="desktopHamburgerLogoUrl"
></deloitteai-page> -->
<div>
  <div *ngIf="subscription_id; then thenBlock; else elseBlock"></div>
</div>
<ng-template #thenBlock><app-chat-thread [subscription_id]="subscription_id"></app-chat-thread></ng-template>
<ng-template #elseBlock><div class="else">
    <h3><b>{{'genai_name' | translate}}</b></h3>
    <h2>
      <p class="mt-3">Welcome to
        <b>{{'genai_name' | translate}}</b>
        <span [innerHTML]="'chat.powered_by' | translate"> </span>
      </p>
    </h2>
    <p class="my-3"> {{'genai_about' | translate}} </p>
    <p>Please select a <b>Subscription</b>:</p>
    <mat-form-field appearance="fill">
      <mat-label>Subscription</mat-label>
      <mat-select (selectionChange)="setSubscription($event.value)">
        <mat-option
          *ngFor="let subscription of subscriptions"
          [value]="subscription.subscription_id">
          {{ subscription.service_nickname }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>
